import React from 'react';
import { observer } from 'mobx-react';
import { WeaDateGroup } from 'ecCom';

@observer
export default class DateGroupNew extends React.Component<any, any>{

    onChange = (v) => {
        const {onChange,fieldid, isChild} = this.props;
        onChange(fieldid,v,isChild);
    }

    render() {
        return <WeaDateGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaDateGroup@3dgstv`} 
            {...this.props}
            onChange={this.onChange}
        ></WeaDateGroup>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/DateGroupNew.tsx